import { render, staticRenderFns } from "./StarsV2.vue?vue&type=template&id=986f99f0&scoped=true"
import script from "./StarsV2.vue?vue&type=script&lang=js"
export * from "./StarsV2.vue?vue&type=script&lang=js"
import style0 from "./StarsV2.vue?vue&type=style&index=0&id=986f99f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986f99f0",
  null
  
)

export default component.exports